import React from 'react';
import { useTranslation } from 'react-i18next';

const CharacterStatsDisplay = ({ stats }) => {
    const { t } = useTranslation();
    const statOrder = ['Speed', 'Stamina', 'Power', 'Guts', 'Wit'];

    const StatItem = ({ name, value, isLast }) => {
        // Translate the stat name dynamically
        const translatedName = t(`CharacterStatsDisplay.stat_${name.toLowerCase()}`);

        return (
            <div className={`w-32 flex flex-col ${!isLast ? 'border-r border-primary-green' : ''}`}>
                {/* Header con nombre de la stat */}
                <div className="bg-primary-green text-white font-bold py-2 uppercase text-xs tracking-wide text-center">
                    {translatedName}
                </div>

                {/* Valor NO editable - sin barra de progreso */}
                <div className="bg-white text-gray-900 py-3 h-20 flex items-center justify-center">
                    <span className="text-xl font-bold text-gray-900">
                        {value || 0}
                    </span>
                </div>
            </div>
        );
    };

    // Renderizar stars como ★★★
    const renderStars = (count) => {
        return '★'.repeat(count);
    };

    if (!stats || stats.length === 0) {
        return (
            <div className="bg-card-white rounded-2xl shadow-xl p-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('CharacterStatsDisplay.title')}</h2>
                <p className="text-gray-500">{t('CharacterStatsDisplay.empty_msg')}</p>
            </div>
        );
    }

    return (
        <div className="bg-card-white rounded-2xl shadow-xl p-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-2">{t('CharacterStatsDisplay.subtitle')}</h2>

            <div className="space-y-8">
                {stats.map((stat, index) => (
                    <div key={index} className="space-y-4">
                        {/* Stars Header Improved */}
                        <div className="flex items-center justify-center">
                            <div className="bg-gray-50 px-6 py-2 rounded-full border border-gray-100 shadow-sm flex items-center gap-2">
                                <span className="text-sm font-bold text-gray-500 uppercase tracking-wider">{t('CharacterStatsDisplay.label_rarity')}</span>
                                <span className="text-2xl text-selected-yellow drop-shadow-sm filter">
                                    {renderStars(stat.Estrellas)}
                                </span>
                            </div>
                        </div>

                        {/* Barra de Stats - Centrada y con ancho máximo */}
                        <div className="flex justify-center">
                            <div className="inline-flex rounded-xl overflow-hidden shadow-lg border border-gray-200">
                                {statOrder.map((statName, statIndex) => (
                                    <StatItem
                                        key={statName}
                                        name={statName}
                                        value={stat[statName] || 0}
                                        isLast={statIndex === statOrder.length - 1}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CharacterStatsDisplay;
// Revisado: 2025-12-18 [I18n Scan]
